import { createClient } from '@supabase/supabase-js'
import { addBreadcrumb } from './sentry';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Check if Supabase is properly configured
const isSupabaseConfigured = supabaseUrl && 
  supabaseAnonKey && 
  supabaseUrl !== 'your_supabase_url_here' && 
  supabaseAnonKey !== 'your_supabase_anon_key_here' &&
  supabaseUrl.startsWith('https://') &&
  supabaseAnonKey.length > 20;

if (!isSupabaseConfigured) {
  addBreadcrumb('Supabase configuration check failed', 'config', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    urlIsPlaceholder: supabaseUrl === 'your_supabase_url_here',
    keyIsPlaceholder: supabaseAnonKey === 'your_supabase_anon_key_here',
    urlFormat: supabaseUrl?.startsWith('https://') ? 'valid' : 'invalid',
    keyLength: supabaseAnonKey?.length || 0
  });
  
  console.warn('Supabase environment variables not configured properly. Check environment setup.');
}

// Create and export the Supabase client
export const supabase = isSupabaseConfigured 
  ? createClient(supabaseUrl!, supabaseAnonKey!)
  : null;

// Export configuration status for other modules to check
export const isSupabaseReady = isSupabaseConfigured;